import { compile } from "vue"

const rootPath = "/analytics"

const moduleRoute = {
    path: rootPath,
    name: "analytics",
    redirect: rootPath + '/settings',
    meta: {
      module: "analytics",
      requiresAuth: true,
      title: "Razayya Financial | Insights | Analytics"
    },
    component: () => import(/* webpackChunkName: "analytics" */ "./analyticsModule.vue" ),
    children: [
        {
            path: rootPath + '/home/:categoryId?',
            name: 'analyticsHome',
            meta: {
                showInNav: true,
                icon: 'mdi-home',
                breadcrumb: {
                    label: 'Reports'
                }
            },
            component: () => import ("./views/ReportItemNavigation.vue")
        },
        {
            path: rootPath + '/kpi',
            name: 'anaytics.kpis',
            meta: {
                showInNav: true,
                icon: 'mdi-poll',
                breadcrumb: {
                    label: 'KPIs',
                    parent: 'analyticsHome'
                }
            },
            component: () => import ("./views/KPIsListView.vue")
        },
        {
            path: rootPath + '/goals',
            name:'analytics.goals',
            
            meta: {
                showInNav: true,
                icon: 'mdi-target',
                breadcrumb: {
                    label: 'Goals',
                    parent: 'analyticsHome'
                }
            },
            component: () => import( "./views/KPIGoalsListView.vue")

        },
        {
            path: rootPath + '/goal-weights',
            name:'analytics.goal-weights',
            
            meta: {
                showInNav: true,
                icon: 'mdi-scale-unbalanced',
                breadcrumb: {
                    label: 'Goal Weights',
                    parent: 'analyticsHome'
                }
            },
            component: () => import( "./views/KPIGoalWeightListView.vue")

        },
        {
            path: rootPath + '/store-groups',
            name: 'analytics.storeGroups',
            meta: {
                showInNav: true,
                icon: 'mdi-store-settings',
                breadcrumb: {
                    label: 'Store Groups',
                    parent: 'analyticsHome'
                }
            },
            component: () => import ("./views/StoreGroupListView.vue")
        },
        {
            path: rootPath + "/report/:categoryId?/:reportId",
            name: 'analytics.report',
            component: () => import("./views/ReportView.vue"),
            meta: {
                breadcrumb: {
                    label: 'Report Details',
                    parent:'analyticsHome'
                }
            }
        },
        {
            path: rootPath + "/settings",
            name: 'analytics.settings',
            component: () => import ("./views/ReportItemNavigation.vue")
        }
    ]
}

export default router => {
    router.addRoute(moduleRoute)
    return moduleRoute
}